import Button from "components/button";
import { PlusOutlined } from '@ant-design/icons';
import { useCRUDAccess } from "utils/useCRUDAccess";

const TableAddButton = ({route, moduleId, ...rest}) => {
	
	const checkCRUDAccess = useCRUDAccess();

  	return ( <>
		{ checkCRUDAccess(moduleId, 'add') && 
			<Button 
				className="crud-button btn-small"
				onClick={() => {
						window.location.href = route;
					}}
			>
				<PlusOutlined />{' '}Add
			</Button>
		}
		</>
  	);
}

export default TableAddButton;
